import { useCryptStore } from "@/store/crypt";
import type { AccessToken, ApiResponse, LoginParams } from "@/utils/api";
import { authApi, noauthApi } from "@/utils/api";
import { globalMessage } from "@/utils/notificationManager.ts";
import { Buffer } from "buffer";
import { create } from "zustand";
import { useTokenStore } from "./token";

interface AuthState {
  login: (params: LoginParams) => Promise<boolean>;
  getCaptcha: () => Promise<string>;
}
export const useLoginStore = create<AuthState>(() => {
  return {
    login: async (params) => {
      const state = useCryptStore.getState();
      const encrypted_data = await state.aes_gcm_encrypt(
        Buffer.from(JSON.stringify(params)).buffer,
      );
      const { data } = await authApi.post<ApiResponse<AccessToken>>(
        "/auth/user/login",
        encrypted_data,
      );
      console.log("Login response:", data);
      if (data.data) {
        const state = useTokenStore.getState();
        state.setAccessToken(data.data.access_token);
        state.setRefreshToken(data.data.refresh_token);
        return true;
      } else {
        globalMessage.error(data.message || "Login failed");
        return false;
      }
    },
    getCaptcha: async () => {
      const { data } =
        await noauthApi.get<ApiResponse<string>>("/auth/user/captcha");
      return data.data!;
    },
  };
});
